import Vue from "vue";
import Vuex from "vuex";
import ParcelData from '../services/ParcelData.js'

Vue.use(Vuex);

export default new Vuex.Store({

   state: {

      settings:{},
      parcels: [],
      dataIsLoaded:false,

      selectedParcelName: null, 
      selectedActuator: null, 
      selectedPhenoPhase: null,
      selectedHypothesis: null, 

      selectedParcelNameG: null,
      selectedActuatorG: null, 
      selectedPhenoPhaseG: null, 
      selectedHypothesisG: null,

      selectedParcelNameD: null, 
      selectedActuatorD: null, 
      selectedPhenoPhaseD: null,
      selectedHypothesisD: null,

      selectedCarac: null,
      selectedMapType: null,

      currentNavPath: null
   },


   getters: {

      getParcels: (state) => {
         return state.parcels;
      },

      getParcelNames: (state) =>{
         return state.parcelNames
      },

      getActuators: (state) =>{
         return state.actuators;
      },

      getCaracs: (state) =>{
         return state.caracs;
      },

      getPhenoPhases: (state) =>{
         return state.phenoPhases;
      },

      getHypotheses:(state) =>{
         return state.hypotheses
      },

      getDataIsLoaded:(state) =>{
         return state.dataIsLoaded
      },

      getSelectedParcelG: (state) =>{
         return state.parcels.find(p => p.parcelName === state.selectedParcelNameG && p.actuator === state.selectedActuatorG && p.phenoPhase === state.selectedPhenoPhaseG && p.hypothesis === state.selectedHypothesis)
      },

      getSelectedParcelD: (state) =>{
         return state.parcels.find(p => p.parcelName === state.selectedParcelNameD && p.actuator === state.selectedActuatorD && p.phenoPhase === state.selectedPhenoPhaseD && p.hypothesis === state.selectedHypothesis)
      },

      getCurrentNavPath: (state) =>{
         return state.currentNavPath
      },
   },

   mutations: {

      setSettings: (state, settings) =>{
         state.settings = settings;
      },
      setParcels: (state, parcels) =>{
         state.parcels = parcels;
      },
      validateDataIsLoaded : (state) =>{
         state.dataIsLoaded =true
      },
      setSelectedParcelName: (state,val) =>{
         state.selectedParcelName =val;
      },
      setSelectedParcelNameG: (state,val) =>{
         state.selectedParcelNameG =val;
      },
      setSelectedParcelNameD: (state,val) =>{
         state.selectedParcelNameD =val;
      },
      setSelectedActuator: (state,val) =>{
         state.selectedActuator =val;
      },
      setSelectedActuatorG: (state,val) =>{
         state.selectedActuatorG =val;
      },
      setSelectedActuatorD: (state,val) =>{
         state.selectedActuatorD =val;
      },
      setSelectedPhenoPhase: (state,val) =>{
         state.selectedPhenoPhase =val;
      },
      setSelectedPhenoPhaseD: (state,val) =>{
         state.selectedPhenoPhaseD =val;
      },
      setSelectedPhenoPhaseG: (state,val) =>{
         state.selectedPhenoPhaseG =val;
      },
      setSelectedHypothesisD: (state,val) =>{
         state.selectedHypothesisD =val;
      },
      setSelectedHypothesisG: (state,val) =>{
         state.selectedHypothesisG =val;
      },
      setSelectedHypothesis: (state,val) =>{
         state.selectedHypothesis =val;
      },
      setSelectedMapType: (state,val) =>{
         state.selectedMapType =val;
      },
      setSelectedCarac: (state,val) =>{
         state.selectedCarac =val;
      },
      setCurrentNavPath: (state,val) =>{
         state.currentNavPath=val;
      },
   },

   actions: {
      //async fetchSettings({commit}) {
      //   const response = await ParcelData.getAllParcels();
      //   const data = await response.json()
      //   commit('setSettings', data);
      //},
   
      async fetchParcels({commit,dispatch}) {
         let {parcels, settings} = await ParcelData.getAllParcels();

         commit('setParcels', parcels);
         commit('setSettings', settings);

         dispatch('setDefault')
         commit ('validateDataIsLoaded')
      },

      setDefault({commit}){
         commit('setSelectedParcelName',this.state.settings.parcelNames[0])
         commit('setSelectedActuator',this.state.settings.actuators[0])
         commit('setSelectedPhenoPhase',this.state.settings.phenoPhases[0])
         commit('setSelectedHypothesis',this.state.settings.hypotheses[0])
         commit('setSelectedMapType',this.state.settings.mapTypes[0])
         commit('setSelectedCarac',this.state.settings.caracs[0])

         commit('setSelectedParcelNameG',this.state.settings.parcelNames[0])
         commit('setSelectedActuatorG',this.state.settings.actuators[0])
         commit('setSelectedPhenoPhaseG',this.state.settings.phenoPhases[0])
         commit('setSelectedHypothesisG',this.state.settings.hypotheses[0])

         if (this.state.settings.parcelNames.length > 1) {
            commit('setSelectedParcelNameD',this.state.settings.parcelNames[1])
            commit('setSelectedPhenoPhaseD',this.state.settings.phenoPhases[0])
         } else if (this.state.settings.phenoPhases.length > 1) {
            commit('setSelectedPhenoPhaseD',this.state.settings.phenoPhases[1])
            commit('setSelectedParcelNameD',this.state.settings.parcelNames[0])
         } else {
            commit('setSelectedParcelNameD',this.state.settings.parcelNames[0])
            commit('setSelectedPhenoPhaseD',this.state.settings.phenoPhases[0])
         }
         commit('setSelectedActuatorD',this.state.settings.actuators[0])
         commit('setSelectedHypothesisD',this.state.settings.hypotheses[0])
      }
   }
});

